import { Typography } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const ReasonTooltip = (row, ...rest) => {
  return row.actionReason ? (
    <Tooltip title={row.actionReason}>
      <Typography component="span" variant="body2">
        {row.actionReason.slice(0, 100)}
      </Typography>
    </Tooltip>
  ) : (
    <></>
  );
};

export default ReasonTooltip;
